import React, { useState } from "react";
import { Button } from "@mui/material";
import { GlobalApplicationState } from "globalApplicationState";
import { push } from "react-router-redux";
import { SendOutlined } from "@mui/icons-material";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";

import LoadingOverlay from "modules/common/components/loadingOverlay";
import BasePage from "pages/common/basePage";
import Header from "pages/common/header";
import MainContent from "pages/common/mainContent";
import MoreOptionsSMS from "./moreOptionsSMS";
import SMSListing from "./smsListing";
import SentSMSDialog from "./sentSMSDialog";
import { reportsApi } from "api/instances";
import { useSetSnackbarMessages } from "modules/common/hooks/useSetSnackbarMessages";
import { ReportTypes } from "modules/reports/models";
import { useDisplayNav } from "modules/common/hooks/useDisplayNav";

interface ISMSManagementPageProps { }

const SMSManagementPage: React.FC<IConnectedSMSManagementPageProps> = ({
    redirectTo,
    tenantId,
    sentConfirmation
}) => {

    const [isLoading, setIsLoading] = useState(false);
    
    const { setSuccessMessage, setErrorMessage } = useSetSnackbarMessages();
    useDisplayNav(true);

    const onDownloadSMSActivity = async (smsId?: string) => {
        setIsLoading(true);

        try { 
            await reportsApi.SendSMSActivityReportRequest(smsId)
            setSuccessMessage("Your report is being generated and will be emailed to you when it's ready.");
        }
        catch {
            setErrorMessage("Something went wrong. Please try again.");
        }
        finally {
            setIsLoading(false);
        }
    }

    const onDownloadSMSReport = async (reportType: ReportTypes) => {
        setIsLoading(true);

        try { 
            await reportsApi.SendSMSReportRequest(reportType)
            setSuccessMessage("Your report is being generated and will be emailed to you when it's ready.");
        }
        catch {
            setErrorMessage("Something went wrong. Please try again.");
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <BasePage fullWidth>
            <LoadingOverlay show={isLoading}/>
            <Header
                title="Manage SMS Messages"
                rightComponent={
                    <React.Fragment>
                        <MoreOptionsSMS
                            onDownloadSMSActivityLog={() => onDownloadSMSActivity()}
                            onDownloadSubscriptionStatus={() => onDownloadSMSReport(ReportTypes.SMSConsentReport)}
                            onDownloadSMSOutbox={() => onDownloadSMSReport(ReportTypes.SMSNotificationReport)}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => redirectTo("/" + tenantId + "/admin/sms/edit/new")}
                            startIcon={<SendOutlined />}
                        >
                            SEND NEW SMS
                        </Button>
                    </React.Fragment>
                }
            />
            <MainContent>
                { sentConfirmation.shouldShowDialog && <SentSMSDialog /> }
                <div className="authoring-page">
                    <SMSListing onDownloadSMSActivity={onDownloadSMSActivity} />
                </div>
            </MainContent>
        </BasePage>
    );
};

const connector = connect(
    (state: GlobalApplicationState, ownProps: RouteComponentProps<ISMSManagementPageProps>) =>
    ({
        ...ownProps,
        sentConfirmation: state.sms.sentConfirmation,
        tenantId: state.tenant.id,
    }),
    {
        redirectTo: push,
    }
);
type IConnectedSMSManagementPageProps = ConnectedProps<typeof connector>;

export default connector(SMSManagementPage);
